import { useCallback, useEffect, useState } from 'react';

export const useIsDragStarted = () => {
  const [isDragStarted, setIsDragStarted] = useState(false);

  const onDragEnter = useCallback(() => setIsDragStarted(true), []);
  const onDragOver = useCallback(() => setIsDragStarted(false), []);

  useEffect(() => {
    window.addEventListener('dragenter', onDragEnter);
    window.addEventListener('mouseup', onDragOver);
    window.addEventListener('drop', onDragOver);
    return () => {
      window.removeEventListener('dragenter', onDragEnter);
      window.removeEventListener('mouseup', onDragOver);
      window.removeEventListener('drop', onDragOver);
    };
  }, []);

  return isDragStarted;
};
